import { autoinject, PLATFORM, transient, useView } from "aurelia-framework";

@autoinject
@transient()
@useView(PLATFORM.moduleName("@rightship-tech/due-diligence-app/views/pages/due-diligence/tabs/documents/due-diligence-documents.html"))
export class DueDiligenceDocuments  {
    
    public vesselId: number;

    activate(model: { vesselId: number}) {
        this.vesselId = model?.vesselId;
    }
}